import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import type { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

interface SidebarItemProps {
  to: string;
  label: string;
  icon: ReactNode;
  collapsed: boolean;
  onClick?: () => void;
}

export function SidebarItem({
  to,
  label,
  icon,
  collapsed,
  onClick,
}: SidebarItemProps): JSX.Element {
  const location = useLocation();
  const isActive = location.pathname === to || location.pathname.startsWith(`${to}/`);

  const button = (
    <ListItemButton
      component={NavLink}
      to={to}
      onClick={onClick}
      selected={isActive}
      sx={{
        minHeight: 48,
        px: 2.5,
        justifyContent: collapsed ? 'center' : 'flex-start',
        '&.Mui-selected': {
          backgroundColor: 'primary.veryLight',
          '&:hover': { backgroundColor: 'primary.veryLight' },
          '& .MuiListItemIcon-root': { color: 'primary.main' },
          '& .MuiListItemText-primary': {
            color: 'primary.main',
            fontWeight: 600,
          },
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: collapsed ? 0 : 2,
          justifyContent: 'center',
        }}
      >
        {icon}
      </ListItemIcon>
      {!collapsed && <ListItemText primary={label} />}
    </ListItemButton>
  );

  return collapsed ? (
    <Tooltip title={label} placement="right" arrow>
      {button}
    </Tooltip>
  ) : (
    button
  );
}
